export const defaultStyle = {
  modalwrpr: "bg-white flex justify-center items-center w-full h-full fixed top-0 left-0 z-10 opacity-[0.7]",
  trendModalContainer:'hidden'
}

export const textPopup = {
  modalwrpr: "bg-black bg-opacity-[0.65] flex justify-center items-center w-full h-full fixed top-0 left-0 z-[10]",
  modalContainer: "bg-white text-lg leading-4 overflow-hidden p-30 absolute w-[600px] max-w-[80%] rounded-[30px]",
  closeBtn: "absolute right-20 top-20 w-20 h-20",
}

export const fullScreenMenu = {
  modalwrpr: "bg-lightGray flex justify-center items-center w-full h-full fixed top-0 left-0 z-10 ",
  modalContainer: "bg-[#36236a] text-lg leading-4 overflow-hidden p-30 absolute  w-full max-w-[100%] rounded-[30px]  h-full text-white",
  closeBtn: "absolute right-20 top-20",
}

export const RECIPE_LIST_FILTER = {
  modalwrpr: "bg-lightBlueBGClr flex justify-center items-center w-full h-full top-0 left-0 z-10 px-20 lg:px-auto absolute",
  modalContainer:'modalContainer absolute top-[50px]'

}

export const TREND_RADAR_CHART = {
  modalwrpr:"TREND_RADAR_CHART fixed top-0 left-0 z-[110]   h-full overflow-hidden w-screen lg:flex lg:items-center lg:justify-center translate-x-[100vw] transition-translate duration-500",
  active:"active !translate-x-0 ",
  modalContainer:`modalContainer relative outline-none scroll-smooth w-[88%] ml-auto lg:mx-auto lg:min-h-[60vh] lg:max-h-[90vh] bg-white pt-[116px] lg:pt-50 lg:pb-[140px] h-full lg:px-70`,
  closeBtn:"closeBtn absolute top-[22px] lg:top-[44px] lg:right-[75px] left-0 lg:left-auto right-0 mx-auto lg:mx-0 w-[40px] h-[40px] bg-purple text-white rounded-[50%] text-18 leading-[1.2] cursor-pointer",
  trendModalContainer:'trendModalContainer lg:backdrop-blur-md bg-black/35 lg:bg-black/25  h-screen  w-screen fixed top-0 transition-opacity ease-out duration-200 opacity-0 invisible z-[100]'
}